(function () {
  /**
   * Scroll affordances for the size tables.
   *
   * The table opens scrolled to the brand column on mobile, so the measurement
   * columns start hidden off to the left with nothing to say so. This flags
   * which side still has content and how wide the pinned column is, and the CSS
   * draws the shadow and chevron from there.
   *
   * Overflow is worked out from cell positions rather than scrollLeft: the
   * scroller is direction:rtl on mobile, and scrollLeft's sign and origin under
   * rtl differ between engines, whereas rects do not.
   */
  var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-b4u-st-wrap]'));
  if (!wraps.length) return;

  /** Folds every label back to the bare arrow. */
  function closeAll() {
    document.querySelectorAll('.b4u-st__hint.is-open').forEach(function (hint) {
      hint.classList.remove('is-open');
    });
  }

  function sync(wrap) {
    var scroller = wrap.querySelector('.b4u-st__scroll');
    if (!scroller) return;

    var headers = scroller.querySelectorAll('thead th');
    if (headers.length < 2) return;

    var box = scroller.getBoundingClientRect();
    var pinned = headers[0];
    var afterPinned = headers[1];
    var last = headers[headers.length - 1];

    // A column clipped past either edge means there is more that way
    var moreLeft = afterPinned.getBoundingClientRect().left < box.left - 1;
    var moreRight = last.getBoundingClientRect().right > box.right + 1;

    wrap.classList.toggle('b4u-st--more-left', moreLeft);
    wrap.classList.toggle('b4u-st--more-right', moreRight);

    // sync runs on scroll and resize, which is exactly when an open label
    // should fold away again
    closeAll();

    // Lets the chevron sit just clear of the pinned column
    wrap.style.setProperty('--st-pinned-w', Math.round(pinned.getBoundingClientRect().width) + 'px');
  }

  wraps.forEach(function (wrap) {
    var scroller = wrap.querySelector('.b4u-st__scroll');
    if (!scroller) return;

    var update = function () { sync(wrap); };
    scroller.addEventListener('scroll', update, { passive: true });
    update();

    // Column widths shift with the viewport, and fonts can land late
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(scroller);
    } else {
      window.addEventListener('resize', update);
    }
  });

  /* ── Tap to unfold ─────────────────────────────────────── */

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-b4u-st-chip]');
    if (!chip) return;
    event.preventDefault();
    var hint = chip.closest('.b4u-st__hint');
    if (!hint) return;
    var wasOpen = hint.classList.contains('is-open');
    closeAll();
    if (!wasOpen) hint.classList.add('is-open');
  });

  // Anything else the visitor does folds it away. pointerdown fires before
  // click, so a tap on the chip itself has to be let through.
  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest('[data-b4u-st-chip]')) return;
    closeAll();
  }, true);

  window.addEventListener('scroll', closeAll, { passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { wraps.forEach(sync); });
  }
})();
